export default "__VITE_ASSET__DCNF1i4W__"